import React, {
  useState,
  useCallback,
  useMemo,
  useEffect,
  useRef,
} from 'react';
import { AgGridReact } from 'ag-grid-react';
// import { toast } from 'react-toastify';
import {
  getProgressCallData,
  getCohortName,
} from '../../../services/apiService';
import { columnDefs, defaultColDef } from '../_utils/columnDefs';
import { Visibility } from '@material-ui/icons';
import ViewRowData from '../_components/ViewRowData';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CustomTooltip from '../../../extras/custom/CustomTooltip';
import { styledDefaultColDef } from '../../../extras/cellRenderers';

const RATING_FILTER_TYPES = {
  LESS_THAN: 'less_than',
  GREATER_THAN: 'greater_than',
  BETWEEN: 'between',
};

const pageSize = 10;

const UploadDataTab = () => {
  const [loading, setLoading] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [cohortFilter, setCohortFilter] = useState('');
  const [typeFilter, setTypeFilter] = useState('');
  const [emailFilter, setEmailFilter] = useState('');
  const [debouncedEmail, setDebouncedEmail] = useState('');
  const [ratingFilterType, setRatingFilterType] = useState('');
  const [ratingFilterValue, setRatingFilterValue] = useState('');
  const [debouncedRatingValue, setDebouncedRatingValue] = useState('');
  const ratingDebounceTimeout = useRef();
  const [ratingFilterMin, setRatingFilterMin] = useState('');
  const [debouncedRatingMin, setDebouncedRatingMin] = useState('');
  const ratingMinDebounceTimeout = useRef();
  const [ratingFilterMax, setRatingFilterMax] = useState('');
  const [debouncedRatingMax, setDebouncedRatingMax] = useState('');
  const ratingMaxDebounceTimeout = useRef();
  let lastRequestedPage = null;
  const emailDebounceTimeout = useRef();
  console.log(lastRequestedPage, 'cara');
  const [cohortOptions, setCohortOptions] = useState([]);
  const [uploadNameOptions, setUploadNameOptions] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  console.log(loading);

  // Debounce email filter
  useEffect(() => {
    if (emailDebounceTimeout.current) {
      clearTimeout(emailDebounceTimeout.current);
    }
    emailDebounceTimeout.current = setTimeout(() => {
      setDebouncedEmail(emailFilter);
    }, 400);
    return () => clearTimeout(emailDebounceTimeout.current);
  }, [emailFilter]);

  // Debounce rating value
  useEffect(() => {
    if (ratingDebounceTimeout.current)
      clearTimeout(ratingDebounceTimeout.current);
    ratingDebounceTimeout.current = setTimeout(() => {
      setDebouncedRatingValue(ratingFilterValue);
    }, 400);
    return () => clearTimeout(ratingDebounceTimeout.current);
  }, [ratingFilterValue]);

  // Debounce rating min
  useEffect(() => {
    if (ratingMinDebounceTimeout.current)
      clearTimeout(ratingMinDebounceTimeout.current);
    ratingMinDebounceTimeout.current = setTimeout(() => {
      setDebouncedRatingMin(ratingFilterMin);
    }, 400);
    return () => clearTimeout(ratingMinDebounceTimeout.current);
  }, [ratingFilterMin]);

  // Debounce rating max
  useEffect(() => {
    if (ratingMaxDebounceTimeout.current)
      clearTimeout(ratingMaxDebounceTimeout.current);
    ratingMaxDebounceTimeout.current = setTimeout(() => {
      setDebouncedRatingMax(ratingFilterMax);
    }, 400);
    return () => clearTimeout(ratingMaxDebounceTimeout.current);
  }, [ratingFilterMax]);

  // Fetch cohort and upload name options on mount
  useEffect(() => {
    async function fetchOptions() {
      try {
        const res = await getCohortName();
        setCohortOptions(res?.allCohorts || []);
        setUploadNameOptions(res?.uploadName || []);
      } catch (err) {
        setCohortOptions([]);
        setUploadNameOptions([]);
      }
    }
    fetchOptions();
  }, []);

  const getServerSideDatasource = () => {
    return {
      getRows: async (params) => {
        console.log('Full params:', params);

        // For server-side row model, we need to handle the request differently
        const { startRow, endRow, sortModel } = params.request || params;
        const page = Math.floor((startRow || 0) / pageSize) + 1;

        console.log('Page calculation:', { startRow, endRow, page, pageSize });

        lastRequestedPage = page;
        setLoading(true);

        try {
          // Prepare sort parameters
          const sortData = [];
          if (sortModel && sortModel.length > 0) {
            sortData.push([
              sortModel[0].colId,
              sortModel[0].sort.toUpperCase(),
            ]);
          }

          // Prepare filter parameters
          const filterData = {};
          if (cohortFilter) filterData.cohortName = cohortFilter;
          if (typeFilter) filterData.typeName = typeFilter;
          if (debouncedEmail) filterData.email = debouncedEmail;
          if (ratingFilterType) {
            filterData.ratingFilter = {
              type: ratingFilterType,
              value: debouncedRatingValue,
              min: debouncedRatingMin,
              max: debouncedRatingMax,
            };
          }
          console.log(filterData, 'filterdatahere');

          const payload = {
            page,
            pageSize: pageSize,
            ...(Object.keys(filterData).length > 0 && { filters: filterData }),
            ...(sortData.length > 0 && { order: sortData }),
          };

          console.log('Fetching data with payload:', payload);
          const response = await getProgressCallData(
            payload.page,
            filterData.cohortName,
            filterData.typeName,
            filterData.email,
            filterData.ratingFilter
          );
          console.log('API Response:', response);

          if (response && response.data) {
            const mappedData = response.data.map((item) => {
              const mappedItem = {
                userId: item.userId,
                firstName: item.User?.firstName || 'N/A',
                lastName: item.User?.lastName || 'N/A',
                email: item.User?.email || 'N/A',
                phone: item.User?.phone || 'N/A',
                courseType:
                  item.User?.UserSubscriptions?.[0]?.courseType || 'N/A',
                planType: item.User?.UserSubscriptions?.[0]?.planType || 'N/A',
                subPlanType:
                  item.User?.UserSubscriptions?.[0]?.subPlanType || 'N/A',
                cohortName:
                  item.User?.UserSubscriptions?.[0]?.cohortName || 'N/A',
                almaxCohortName:
                  item.User?.UserSubscriptions?.[0]?.almaxCohortName || 'N/A',
                enrolmentOn:
                  item.User?.UserSubscriptions?.[0]?.enrolmentOn || 'N/A',
                progress: item.progress || 'N/A',
                progressUpdatedAt: item.progressUpdatedAt || 'N/A',
                POC: item.pocName || 'N/A',
                contactDate: item.contactDate || 'N/A',
                callStatus: item.callStatus || 'N/A',
                'Q: How effective is your learning at almabetter? - rating':
                  item.data?.questions?.[
                    'How effective is your learning at almabetter?'
                  ]?.rating || 'N/A',
                'Q: How effective is your learning at almabetter? - remark':
                  item.data?.questions?.[
                    'How effective is your learning at almabetter?'
                  ]?.remark || 'N/A',
                'Q: How effective are the live classes or the recordings? - rating':
                  item.data?.questions?.[
                    'How effective are the live classes or the recordings?'
                  ]?.rating || 'N/A',
                'Q: How effective are the live classes or the recordings? - remark':
                  item.data?.questions?.[
                    'How effective are the live classes or the recordings?'
                  ]?.remark || 'N/A',
                'Q: How would you rate the overall quality of the course content? - rating':
                  item.data?.questions?.[
                    'How would you rate the overall quality of the course content?'
                  ]?.rating || 'N/A',
                'Q: How would you rate the overall quality of the course content? - remark':
                  item.data?.questions?.[
                    'How would you rate the overall quality of the course content?'
                  ]?.remark || 'N/A',
                'Q: How effective are the support services? - rating':
                  item.data?.questions?.[
                    'How effective are the support services?'
                  ]?.rating || 'N/A',
                'Q: How effective are the support services? - remark':
                  item.data?.questions?.[
                    'How effective are the support services?'
                  ]?.remark || 'N/A',
                'Q: How satisfied are you with the overall user experience on the platform? - rating':
                  item.data?.questions?.[
                    'How satisfied are you with the overall user experience on the platform?'
                  ]?.rating || 'N/A',
                'Q: How satisfied are you with the overall user experience on the platform? - remark':
                  item.data?.questions?.[
                    'How satisfied are you with the overall user experience on the platform?'
                  ]?.remark || 'N/A',
                overallRemark: item.overallRemark || 'N/A',
                pocRemark: item.pocRemark || 'N/A',
                care: item.care || 'N/A',
                exotelReference: item.exotelReference || 'N/A',
                qaStatus: item.qaStatus || 'N/A',
                qaRemark: item.qaRemark || 'N/A',
                callingRound: item.callingRound || 'N/A',
                averageRating: item.averageRating || 'N/A',
                'type-name': item.typeName || 'N/A',
                questions: item.data?.questions || {},
              };
              return mappedItem;
            });

            // Pass the total row count to the grid
            const totalRows = response.totalRecords || 0;
            console.log(totalRows, 'torakdatahere');
            params.successCallback(mappedData, totalRows);
          } else {
            params.successCallback([], 0);
          }
        } catch (error) {
          console.error('Error fetching data:', error);
          params.failCallback();
        } finally {
          setLoading(false);
        }
      },
    };
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
    const datasource = getServerSideDatasource();
    params.api.setServerSideDatasource(datasource);
    params.api.sizeColumnsToFit();
  };

  const handleViewRow = (rowData) => {
    setSelectedRow(rowData);
    setModalOpen(true);
  };

  const agGridColumnDefs = useMemo(() => {
    // Find the index of 'callStatus' column
    const callStatusIndex = columnDefs.findIndex(
      (col) => col.field === 'callStatus'
    );
    // Create a copy of columnDefs
    const newColumnDefs = [...columnDefs];
    // Define the Questions column
    const questionsCol = {
      headerName: 'Questions',
      field: 'questions',
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: {
        suppressCount: true,
        innerRenderer: () => 'View Questions',
      },
      minWidth: 180,
      flex: 1,
    };
    // Insert the Questions column after 'callStatus'
    newColumnDefs.splice(callStatusIndex + 1, 0, questionsCol);
    // Add the eye icon column at the end
    newColumnDefs.push({
      headerName: 'Action',
      field: 'actions',
      minWidth: 100,
      maxWidth: 180,
      width: 150,
      cellRendererFramework: (params) => (
        <button
          onClick={() => handleViewRow(params.data)}
          className='ml-2 text-gray-700 hover:text-blue-600'
          title='View details'
        >
          <Visibility style={{ fontSize: 20 }} />
        </button>
      ),
      pinned: 'false',
      suppressMenu: true,
      sortable: false,
      filter: false,
    });
    return newColumnDefs;
  }, []);

  const handleFilterChange = useCallback(() => {
    if (gridApi) {
      // Reset to first page when filters change
      lastRequestedPage = null;
      gridApi.paginationGoToPage(0);

      // Create new datasource with updated filters
      const newDatasource = getServerSideDatasource();
      gridApi.setServerSideDatasource(newDatasource);
    }
  }, [
    cohortFilter,
    typeFilter,
    debouncedEmail,
    ratingFilterType,
    debouncedRatingValue,
    debouncedRatingMin,
    debouncedRatingMax,
  ]);

  useEffect(() => {
    handleFilterChange();
    // eslint-disable-next-line
  }, [
    cohortFilter,
    typeFilter,
    debouncedEmail,
    debouncedRatingValue,
    debouncedRatingMin,
    debouncedRatingMax,
  ]);

  const clearFilters = () => {
    setCohortFilter('');
    setTypeFilter('');
    setEmailFilter('');
    setRatingFilterType('');
    setRatingFilterValue('');
    setRatingFilterMin('');
    setRatingFilterMax('');
    handleFilterChange();
  };

  return (
    <div className='p-4'>
      {/* Filters Section */}
      <div className='bg-white p-4 rounded-lg shadow mb-4'>
        <div className='flex items-center justify-between mb-4'>
          <h2 className='text-lg font-semibold'>Data Filters</h2>
          {(cohortFilter || typeFilter || emailFilter || ratingFilterType) && (
            <button
              onClick={clearFilters}
              className='bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2 rounded-md ml-4'
            >
              Clear Filters
            </button>
          )}
        </div>
        <div className="w-full flex flex-col lg:flex-row lg:items-end lg:gap-4">
          {/* Cohort Filter */}
          <div className="flex flex-col w-full lg:w-60 mb-2 lg:mb-0">
            <label className="block text-sm font-medium text-gray-700 mb-1">Cohort Name</label>
            <Autocomplete
              options={cohortOptions.map((c) => c.cohortName)}
              value={cohortFilter}
              onChange={(event, newValue) => setCohortFilter(newValue || '')}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="All Cohorts"
                  variant="outlined"
                  size="small"
                />
              )}
              freeSolo
              clearOnEscape
            />
          </div>

          {/* Upload Name */}
          <div className="flex flex-col w-full lg:w-80 mb-2 lg:mb-0">
            <label className="block text-sm font-medium text-gray-700 mb-1">Upload Name</label>
            <Autocomplete
              options={uploadNameOptions.map((u) => u.typeName)}
              value={typeFilter}
              onChange={(event, newValue) => setTypeFilter(newValue || '')}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="All Types"
                  variant="outlined"
                  size="small"
                />
              )}
              freeSolo
              clearOnEscape
            />
          </div>

          {/* Email Filter */}
          <div className="flex flex-col w-full lg:w-80 mb-2 lg:mb-0">
            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
            <input
              type="text"
              value={emailFilter}
              onChange={(e) => setEmailFilter(e.target.value)}
              placeholder="Search by email"
              className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          {/* Rating Filter */}
          <div className="flex flex-col w-full lg:w-72">
            <label className="block text-sm font-medium text-gray-700 mb-1">Rating Filter</label>
            <div className="flex gap-2 items-center flex-nowrap">
              <select
                value={ratingFilterType}
                onChange={(e) => setRatingFilterType(e.target.value)}
                className="border border-gray-300 rounded-md px-2 py-2 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white w-60 min-w-[200px]"
              >
                <option value="">Type</option>
                <option value={RATING_FILTER_TYPES.LESS_THAN}>Less Than or Equal To</option>
                <option value={RATING_FILTER_TYPES.GREATER_THAN}>Greater Than or Equal To</option>
                <option value={RATING_FILTER_TYPES.BETWEEN}>Between</option>
              </select>
              {ratingFilterType === RATING_FILTER_TYPES.BETWEEN ? (
                <div className='flex gap-2 items-center flex-nowrap'>
                  <input
                    type='number'
                    value={ratingFilterMin}
                    onChange={(e) => setRatingFilterMin(e.target.value)}
                    placeholder='Min'
                    min='0'
                    max='5'
                    step='0.1'
                    className='border border-gray-300 rounded-md px-2 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-20 min-w-[80px]'
                  />
                  <span className='mx-1'>-</span>
                  <input
                    type='number'
                    value={ratingFilterMax}
                    onChange={(e) => setRatingFilterMax(e.target.value)}
                    placeholder='Max'
                    min='0'
                    max='5'
                    step='0.1'
                    className='border border-gray-300 rounded-md px-2 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 w-20 min-w-[80px]'
                  />
                </div>
              ) : (
                ratingFilterType && (
                  <input
                    type='number'
                    value={ratingFilterValue}
                    onChange={(e) => setRatingFilterValue(e.target.value)}
                    placeholder='Enter rating'
                    min='0'
                    max='5'
                    step='0.1'
                    className='border border-gray-300 rounded-md px-2 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                    style={{ width: '150px', minWidth: '120px' }}
                  />
                )
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Grid Section */}
      <div className='bg-white p-4 rounded-lg shadow'>
        <div
          className='ag-theme-alpine h-full w-full'
          style={{ height: '100%' }}
        >
          {' '}
          <AgGridReact
            columnDefs={agGridColumnDefs}
            defaultColDef={defaultColDef}
            rowModelType='serverSide'
            pagination={true}
            paginationPageSize={pageSize}
            cacheBlockSize={pageSize}
            onGridReady={onGridReady}
            loadingOverlayComponent={() => (
              <div className='flex items-center justify-center h-full'>
                {/* ksd */}
              </div>
            )}
            loadingOverlayComponentParams={{
              loadingMessage: 'Loading data...',
            }}
            tooltipShowDelay={500}
            tooltipHideDelay={2000}
            enableBrowserTooltips={true}
            popupParent={document.querySelector('.ag-theme-alpine')}
            suppressPaginationPanel={false}
            domLayout='autoHeight'
            animateRows={true}
            enableCellTextSelection={true}
            ensureDomOrder={true}
            suppressRowClickSelection={true}
            suppressCellFocus={false}
            suppressColumnVirtualisation={false}
            suppressRowVirtualisation={false}
            rowHeight={48}
            headerHeight={48}
            serverSideStoreType='partial'
            masterDetail={true}
            detailCellRendererParams={{
              detailGridOptions: {
                columnDefs: [
                  { headerName: 'Question', field: 'question', flex: 2 },
                  {
                    headerName: 'Rating',
                    field: 'rating',
                    minWidth: 60,
                    maxWidth: 100,
                    width: 90,
                  },
                  {
                    headerName: 'Remark',
                    field: 'remark',
                    flex: 2,
                    // tooltipField: 'remark',
                    tooltipField: 'remark',
                    tooltipComponent: CustomTooltip,
                    // tooltipComponentParams: { isPopup: true }, 
                    tooltipValueGetter: (params) => params.value,
                    cellRendererFramework: (params) => (
                      <div
                        style={{
                          display: 'block',
                          width: '100%',
                          overflowWrap: 'break-word',
                          wordBreak: 'break-word',
                          whiteSpace: 'pre-line',
                        }}
                      >
                        {params.value}
                      </div>
                    ),
                  },
                ],
                defaultColDef: { ...styledDefaultColDef },
              },
              getDetailRowData: (params) => {
                const questionsObj = params.data?.questions || {};
                const detailRows = Object.keys(questionsObj).map((q) => ({
                  question: q,
                  rating: questionsObj[q]?.rating,
                  remark: questionsObj[q]?.remark,
                }));
                params.successCallback(detailRows);
              },
            }}
          />
        </div>
      </div>
      {modalOpen && selectedRow && (
        <ViewRowData
          isOpen={modalOpen}
          setIsOpen={setModalOpen}
          currentRowData={selectedRow}
        />
      )}
    </div>
  );
};

export default UploadDataTab;
